module.exports = __webpack_public_path__ + "static/media/Avenir-Black.fcd3abb2.otf";